import { render, staticRenderFns } from "./homeSSwiper.vue?vue&type=template&id=0d5afa7d&scoped=true&"
import script from "./homeSSwiper.vue?vue&type=script&lang=js&"
export * from "./homeSSwiper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5afa7d",
  null
  
)

export default component.exports